import { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import api from '../lib/api';

export default function VerifyEmail() {
  const [params] = useSearchParams();
  const [state, setState] = useState('working');
  useEffect(() => {
    api.post('/api/public/portal/verify-email', { token: params.get('token') }).then(() => setState('ok')).catch(() => setState('bad'));
  }, [params]);
  return (
    <div className="min-h-screen flex items-center justify-center bg-background p-6">
      <div className="max-w-sm space-y-4" data-testid="verify-email-page">
        <h1 className="text-4xl font-headings font-bold">Confirm email</h1>
        {state === 'working' && <p className="text-sm">Checking your link…</p>}
        {state === 'ok' && <p className="text-sm" data-testid="verify-email-ok">Thanks – your new address is confirmed. Your accountant will approve the change, then you'll sign in with it.</p>}
        {state === 'bad' && <p className="text-sm text-destructive" data-testid="verify-email-bad">This link is invalid or has expired.</p>}
        <Link to="/login" className="text-sm underline">Go to sign in</Link>
      </div>
    </div>
  );
}
